import { Col, Row, Statistic, Typography } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const { Title, Text } = Typography;


export default function StatisticsHours(props) {
    const { data, lotto, amount, type, color, colorText, icon } = props;
    const hoursObj = JSON.parse(data);
    const chartData = Object.entries(hoursObj).map(([key, value]) => ({
        name: `${key.replace('H', '')}:00`,
        ventas: value,
    }));


    return (
        <>
            <header style={{ marginBottom: '24px', textAlign: 'center' }}>
                <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12}>
                        <Title level={4} style={{ margin: 0, color: color }}>
                            <BarChartOutlined /> Reporte de Sorteo #{lotto?.lottoNumber}
                        </Title>
                        <Text type="secondary">Estadísticas de {type.toLowerCase()} por hora</Text>
                    </Col>
                    <Col xs={12} sm={12}>
                        <Statistic
                            title={type}
                            value={amount}
                            prefix={icon}
                            valueStyle={{ color: color, fontWeight: 'bold' }}
                        />
                    </Col>
                </Row>
            </header>

            <div style={{ width: '100%', height: 350 }}>
                <ResponsiveContainer>
                    <BarChart
                        data={chartData}
                        margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" />
                        <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#666', fontSize: 12 }}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#666', fontSize: 12 }}
                        />
                        <Tooltip
                            cursor={{ fill: 'rgba(212, 175, 55, 0.1)' }}
                            contentStyle={{
                                borderRadius: '8px',
                                background: '#fff'
                            }}
                        />
                        <Bar
                            dataKey="ventas"
                            radius={[4, 4, 0, 0]}
                        >
                            {chartData.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.ventas > 0 ? color : '#c8ffc3ff'}
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>

            <footer style={{ marginTop: '15px', textAlign: 'center' }}>
                <Text style={{ fontSize: '12px', color: '#8c8c8c' }}>
                    * Las barras en <span style={{ color: color, fontWeight: 'bold' }}>{colorText}</span> indican actividad registrada.
                </Text>
            </footer>
        </>
    );
}